// Export redux selectors
export const selectServiceList = (state) => state.service.services;
export const selectServiceLoadingStatus = (state) => state.service.fetchingData;
export const selectSelectedService = (state) => state.service.service;